import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IField } from '@/types/tasksApprovals'

interface IWorkdayDetails {
    date: string
    day_of_the_week: string
    total_units: string
}

const TimeOfDetails = ({ item }: { item: IField }) => {
    const theadColor = useColorModeValue('status.info', 'rgba(255,255,255, .4)')
    const { t } = useTranslation()

    return (
        <Box py="8px" px="24px">
            <Text fontSize={14} pb="4px">
                {item.name}
            </Text>
            <Flex dir="row" width="100%" mb="4px">
                <Box width="35%">
                    <Text fontSize={12} textTransform="uppercase" color={theadColor}>
                        {t('tasksApprovals.workDayDrawer.details.date')}
                    </Text>
                </Box>
                <Box width="45%">
                    <Text fontSize={12} textTransform="uppercase" color={theadColor}>
                        {t('tasksApprovals.workDayDrawer.details.dayOfTheWeek')}
                    </Text>
                </Box>
                <Box width="20%">
                    <Text fontSize={12} textTransform="uppercase" color={theadColor}>
                        {t('tasksApprovals.workDayDrawer.details.totalUnits')}
                    </Text>
                </Box>
            </Flex>

            {(item.value as IWorkdayDetails[]).map((detail) => (
                <Flex dir="row" width="100%" mb="4px" key={detail.date}>
                    <Box width="35%">
                        <Text fontSize={14} fontWeight="bold">
                            {detail.date}
                        </Text>
                    </Box>
                    <Box width="45%">
                        <Text fontSize={14} fontWeight="bold">
                            {detail.day_of_the_week}
                        </Text>
                    </Box>
                    <Box width="20%">
                        <Text fontSize={14} fontWeight="bold">
                            {detail.total_units}
                        </Text>
                    </Box>
                </Flex>
            ))}
        </Box>
    )
}

export default TimeOfDetails
